module.exports = __webpack_public_path__ + "img/openstax.b41d74e9.png";